import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = ({ trackingId }) => {
  const location = useLocation();

  useEffect(() => {
    // Load Google Analytics script
    if (trackingId && typeof window !== 'undefined') {
      // Initialize gtag if not already loaded
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', trackingId, {
        page_path: location.pathname + location.search,
      });

      // Load the script if not already loaded
      if (!document.querySelector(`script[src*="gtag"]`)) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        document.head.appendChild(script);
      }
    }
  }, [trackingId, location.pathname, location.search]);

  // Track page views on route change
  useEffect(() => {
    if (trackingId && typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', trackingId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, trackingId]);

  return null;
};

export default GoogleAnalytics;

